import React from 'react';
import { PageTitle } from '@cordata/buffet';

import InsuranceCarriersForm from '~/components/InsuranceCarrier/Form';

const InsuranceCarriersAdd = () => (
  <>
    <PageTitle>Add Insurance Carrier</PageTitle>

    <InsuranceCarriersForm />
  </>
);

export default InsuranceCarriersAdd;
